<template>
    <div class="carsiLogin">        
    </div>
</template>
<script>
import Axios from "axios";
import { env } from '../../dataJson/custom.js'
import Cookie from "js-cookie"
import {  loginInfo, login, checkCode, readerAutoLogin, getLoginOrgInfo } from "@/api/login"
import {  generator } from "@/api/colinfo"
import { getUserInfo, setItem } from "@/common/utils/localStorage.js";
import MD5 from "../../common/utils/MD.js"
import { roleAuth, infoLogin, autoLogin, validity, setConfig } from "@/api/user";

export default {
    inject: ['reload'],
    name: "Login",
    data() {
        return {
            isOrgArg: false,
            hasOrg: false,
            userInfo: getUserInfo(),
            logining: false,
            loginform: {
                userName: "",
                userPwd: "",
            },
            isChecked: true,//30天记住密码
            // 表单验证，需要在 el-form-item 元素中增加 prop 属性
            rules: {
                user: [
                    {
                        required: true,
                        message: "账号不可为空",
                        trigger: "blur",
                    },
                ],
                userPwd: [
                    {
                        required: true,
                        message: "密码不可为空",
                        trigger: "blur",
                    },
                ],
            },
            usernameText: "",
            passwordText: "",
            // 对话框显示和隐藏
            //部门列表，用来下拉列表模糊查询
            deptListLikeInfo:[],
            //筛选完的部门列表信息
            deptListFilter:[],
            loading: false,
            deptId: "",
            info: [],
            countryOpt: [],
            Value: "",
            orgType: "",
            jointState: "",
            authKey: "",
            sign: "",
            pkid: "",
            autoLoginSignal: "",
            ytzhGid: "",
            autoLoginSwitcher: "",
        };
    },
    created() {
        let vm = this;
        // vm.validity();
        // vm.infoLogin();
    },
    mounted() {
        let vm = this;
        if(Object.getOwnPropertyNames(vm.userInfo).length === 0){
            vm.$router.push({name:"HomePage"});
        }else{
            //carsi登录
            let obj = vm.$route.query;
            const loginLoading = this.$loading({
                lock: true,
                text: '正在登陆中，请耐心等待...',
                spinner: 'el-icon-loading',
                background: 'rgba(255, 255, 255, 0.7)'
            });
            // Axios.post('/auth/ttv3/security/core/carsi/login', {
            Axios.post(env+'/ttv3/security/core/carsi/login', {
                code: obj.code,
                state: obj.state
            }).then(response => {
                let res = response.data;
                loginLoading.close();
                if(res && res.code==200){
                    if(obj.state == 'tiantianyuedu'){
                        setItem("token", res.data.token);
                        setItem("orgId", res.data.orgId);
                        setItem("userId", res.data.pkid);
                        setItem("userInfo", res.data);
                        setItem("authKey", res.data.loginRedisKey);
                        setItem("demoSignal", res.data.demoSignal);
                        setItem("account", res.data.account);                        
                        // console.log(res.data.orgId + "|#|" + res.data.pkid + "|#|" + res.data.token);
                        vm.authKey = MD5(res.data.orgId + "|#|" + res.data.pkid + "|#|" + res.data.token);
                        let obj = {
                            "authKey": vm.authKey,
                            "visitType": 2,
                            "visitUrl": location.href,
                            "visitFunc": "",
                        };
                        generator(obj).then((res2) => {
                            vm.sign = res2.code;
                            setItem("sign", res2.data);
                            if(vm.sign == "") {
                                vm.$router.push({name:"Login"});
                            } else {
                                vm.$message({
                                    "message": "登陆成功",
                                    "type": "success"
                                });
                                if(localStorage.getItem('remindLink') != null) {
                                    vm.$router.push({ path: localStorage.getItem('remindLink') })
                                    localStorage.removeItem("remindLink");
                                } else {
                                    vm.$router.push({name:"HomePage"});
                                }
                            }
                            vm.loading = false;
                        });
                    }else{
                        vm.$message({
                            "message": res.errorMsg || "登陆失败！请重试...",
                            "type": "warning"
                        });
                        vm.$router.push({name:"Login"})
                    }
                }else if(obj.state == 'yuntiangou'){
                    // window.location.href = 'http://192.168.7.199:8082/#/carsiLogin?uid='+res.data.carsi_persistent_uid;
                }
            }).catch(err => {
                loginLoading.close();
            });
        }        
    },
    methods: {
        //获取权限显示
        getSetConfig(){
            let vm = this,
                obj = {
                    // orgId: getUserInfo().orgId,
                    visitType: 2,
                    visitUrl: location.href,
                    visitFunc: "",
                };
            setConfig(obj).then(res => {
                if(res.status){
                    // t.config = res.data;
                    let configData = [],
                        list = {};
                    for(var i = 1;i<=40;i++){
                        let list = {type:i, orgId:getUserInfo().orgId, dataStatus:1, enableStatus: 2}; //默认不显示
                        res.data.map((item, index) =>{
                            if(item.type == i){
                                // list.pkid = item.pkid;
                                list.enableStatus = item.enableStatus;
                                return true;
                            }
                        });
                        configData.push(list);
                    }
                    // t.config = configData;
                    setItem('config', JSON.stringify(configData));
                    vm.$message({
                        message: "登录成功！",
                        type: "success"
                    });
                    if(localStorage.getItem('remindLink') != null) {
                        vm.$router.push({ path: localStorage.getItem('remindLink') })
                        localStorage.removeItem("remindLink");
                    } else {
                        vm.$router.push({name:"HomePage"})
                    }
                }
            }).catch(err => {

            });
        },
        //自动登录
        autoLoginByOrgId(orgId, orgName){
            let vm = this,
                formData = {orgId: orgId, autoLoginSwitcher: 3};
            //自动登录
            readerAutoLogin(formData).then(res => {
        		if(res && res.code==200){
                    vm.loading = true;
                    setItem("token", res.data.token);
                    setItem("orgId", res.data.orgId);
                    setItem("userId", res.data.pkid);
                    setItem("userInfo", res.data);
                    setItem("authKey", res.data.loginRedisKey);
                    setItem("demoSignal", res.data.demoSignal);
                    setItem("account", res.data.account);
                    console.log(res.data.orgId + "|#|" + res.data.pkid + "|#|" + res.data.token);
                    vm.authKey = MD5(res.data.orgId + "|#|" + res.data.pkid + "|#|" + res.data.token);
                    let obj = {
                        "authKey": vm.authKey,
                        "visitType": 2,
                        "visitUrl": location.href,
                        "visitFunc": "",
                    };
                    generator(obj).then((res2) => {
                        vm.sign = res2.code;
                        setItem("sign", res2.data);
                        if(vm.sign == "") {
                            vm.$router.push({name:"Login"});
                        } else {
                            vm.getSetConfig();
                            // vm.$message({
                            //     "message": "登陆成功",
                            //     "type": "success"
                            // });
                            // if(localStorage.getItem('remindLink') != null) {
                            //     vm.$router.push({ path: localStorage.getItem('remindLink') })
                            //     localStorage.removeItem("remindLink");
                            // } else {
                            //     vm.$router.push({name:"HomePage"})
                            // }
                        }
                        vm.loading = false;
                    });
                }else{
                    vm.hasOrg = true;//显示切换
                    vm.isOrgArg = true;
                    vm.pkid = orgId;
                    vm.deptId = orgName; 
                }
            }).catch(err => {  

            });
        },
        //根据登录传参获取机构名称和机构id
        getParamOrgId(dircode){
            let vm = this;
            getLoginOrgInfo({dirCode: dircode}).then(res => {
                if(res.status){
                    // vm.deptId = res.data.orgName;
                    // vm.pkid = res.data.orgId;
                    if(Object.keys(res.data).length > 0 && res.data.orgName){
                        vm.autoLoginByOrgId(res.data.orgId, res.data.orgName);
                    }else{
                        vm.hasOrg = false;
                    }
                }
            }).catch(err => {

            });
        },
        //切换结构
        // changeOrg(){
        //     let vm = this;
        //     vm.dircode
        // },
        //选择机构自动登录
        change(val) {
            let vm = this;
            vm.info.map(item => {
                if(item.pkid === val) {
                    vm.pkid = item.pkid;
                    vm.Value = item.orgName;
                    vm.orgType = item.orgType;
                    vm.jointState = item.jointState;
                    vm.autoLoginSignal = item.autoLoginSignal;
                    vm.ytzhGid = item.ytzhGid;
                }
            });
            // if(vm.autoLoginSignal == 2 || vm.autoLoginSignal == 3) {
            //     vm.roleAuth()
            // }
        },
        checkCode() {
            let vm = this
            let userInfo = getUserInfo();
            var obj = {
                token: localStorage.getItem('token'),
                "visitType": 2,
                "visitUrl": location.href,
                "visitFunc": "",
            };
            checkCode(obj).then((res) => {
                if(res.code == 200) {
                    if(localStorage.getItem('remindLink') != null) {
                        this.$router.push({ path: localStorage.getItem('remindLink') })
                        localStorage.removeItem("remindLink");
                    } else {
                        this.$router.push('HomePage')
                    }
                }
            });
        },
        validity() {
            let vm = this
            let userInfo = getUserInfo();
            var obj = {
                "visitType": 2,
                "visitUrl": location.href,
                "visitFunc": "",
            };
            validity(obj).then((res) => {
                if(res){
                    if(res.data != null && res.data.validityStatus == 2) {
                        this.$router.push({ name: "404" })
                    } else {
                        vm.Info()
                        vm.infoLogin()
                        let userInfo = getUserInfo();
                        if (localStorage.getItem('token') != null) {
                            vm.checkCode()
                        }
                    }
                }else{
                    console.log('789778777');
                }
            });
        },
        // 判断是否自动登录
        roleAuth() {
            let vm = this
            let userInfo = getUserInfo();
            var obj = {
                "orgId": vm.pkid,
                "visitType": 2,
                "visitUrl": location.href,
                "visitFunc": "",
            };
            roleAuth(obj).then((res) => {
                vm.loginform.userName = res.data.account
                vm.loginform.userPwd = res.data.accountPwd
                vm.autoLoginSignal = res.data.autoLoginSignal
                vm.login()
            });
        },
        //用户名
        loginInfo(query) {
            let vm = this,
            obj = {
                "orgStatus": 1,
                "deviceType": 1,
                "orgName": query,
                "orgType": 1,
                "visitType": 2,
                "visitUrl": location.href,
                "visitFunc": "",
            };
            if(query) {
                loginInfo(obj).then((res) => {
                    this.info = res.data.list
                }); 
            } else {
                vm.Info()
            }
        },
        Info() {
            let vm = this,
            obj = {
                "orgStatus": 1,
                "deviceType": 1,
                "visitType": 2,
                "jointState": 4,
                "visitUrl": location.href,
                "visitFunc": "",
                // "pageNum": vm.pageNum,
                // "pageSize": 20,
            };
            loginInfo(obj).then((res) => {
                vm.info = res.data.list;
            }); 
        },
        // 登录
        login() {
            let userInfo = getUserInfo();
            let vm = this;
            var obj = {
                "account": vm.loginform.userName,
                "accountPwd": vm.loginform.userPwd,
                "autoLoginSignal": 3,
                "ytzhOrgId": '9005',
                // "autoLoginSignal": vm.autoLoginSignal,
                // "ytzhOrgId": vm.ytzhGid,
                "joinState": 4,
                "orgId": vm.pkid,
                "visitType": 2,
                "visitUrl": location.href,
                "visitFunc": "",
            };
            login(obj).then((res) => {
                if(res.code == "200") {
                    this.loading = true;
                    setItem("token", res.data.token);
                    setItem("orgId", res.data.orgId);
                    setItem("userId", res.data.pkid);
                    setItem("userInfo", res.data);
                    setItem("authKey", res.data.loginRedisKey);
                    setItem("demoSignal", res.data.demoSignal);
                    setItem("account", res.data.account);
                    
                    let userInfo = getUserInfo();
                    this.authKey = MD5(userInfo.orgId + "|#|" + userInfo.pkid + "|#|" + userInfo.token)
                    let vm = this,
                    obj = {
                        "authKey": vm.authKey,
                        "visitType": 2,
                        "visitUrl": location.href,
                        "visitFunc": "",
                    };
                    generator(obj).then((res) => {
                        vm.sign = res.code
                        setItem("sign", res.data);
                        if(vm.sign == "") {
                            this.$router.push({name:"Login"})
                        } else {
                            this.$message({
                                "message": "登陆成功",
                                "type": "success"
                            })
                            if(localStorage.getItem('remindLink') != null) {
                                this.$router.push({ path: localStorage.getItem('remindLink') })
                                localStorage.removeItem("remindLink");
                            } else {
                                this.$router.push({name:"HomePage"})
                            }
                        }
                        vm.loading = false;
                    });
                }
                if (res.status == "500") {
                    this.$message({
                        "message": "登陆失败，请联系管理员",
                        "type": "error"
                    })
                }
            });
        },
        //自动登录，第一种情况：根据ip自动登录。第二种情况：学校部署
        infoLogin() {
            let vm = this,
            obj = {
                "visitType": 2,
                "visitUrl": location.href,
                "visitFunc": "",
            };
            infoLogin(obj).then((res) => {
                vm.orgId = res.data.orgId;
                if(vm.orgId == null || vm.orgId == '0') {
                    
                } else {
                    vm.autoLoginSwitcher = res.data.autoLoginSwitcher
                    vm.autoLogin()
                }
            }); 
        },
        autoLogin() {
            let vm = this,
            obj = {
                autoLoginSwitcher: vm.autoLoginSwitcher,
                orgId: vm.orgId,
                "visitType": 2,
                "visitUrl": location.href,
                "visitFunc": "",
            };
            autoLogin(obj).then((res) => {
                if(res.code == "200") {
                    this.loading = true;
                    setItem("token", res.data.token);
                    setItem("orgId", res.data.orgId);
                    setItem("userId", res.data.pkid);
                    setItem("userInfo", res.data);
                    setItem("authKey", res.data.loginRedisKey);
                    setItem("demoSignal", res.data.demoSignal);
                    setItem("account", res.data.account);

                    let userInfo = getUserInfo();
                    this.authKey = MD5(userInfo.orgId + "|#|" + userInfo.pkid + "|#|" + userInfo.token)
                    let vm = this,
                        obj = {
                            "authKey": vm.authKey,
                            "visitType": 2,
                            "visitUrl": location.href,
                            "visitFunc": "",
                        };
                    generator(obj).then((res) => {
                        vm.sign = res.code
                        setItem("sign", res.data);
                        if(vm.sign == "") {
                            this.$router.push({name:"Login"})
                        } else {
                            this.$message({
                                "message": "登陆成功",
                                "type": "success"
                            })
                            if(localStorage.getItem('remindLink') != null) {
                                this.$router.push({ path: localStorage.getItem('remindLink') })
                                localStorage.removeItem("remindLink");
                            } else {
                                this.$router.push({name:"HomePage"})
                            }
                        }
                        vm.loading = false;
                    });
                }
            }); 
        },
    },
};
</script>
 
<style lang="scss" scoped>
.carsiLogin{
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    background-color: #c3ecff;
}
</style>


// WEBPACK FOOTER //
// src/views/Login/carsiLogin.vue